import {MatterDocument} from "common/types/matter";

export const getMostRecentDocument = (
  documents: MatterDocument[],
  documentTypeId: number,
): MatterDocument | null => {
  const filtered = documents
    .filter(doc => doc.document_type_id === documentTypeId)
    .sort(
      (a, b) =>
        new Date(b.creation_date).getTime() -
        new Date(a.creation_date).getTime(),
    );
  return filtered[0] || null;
};
